// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2551) return "static/chunks/2551-d28f200477c231f8.js";
	if (chunkId === 9312) return "static/chunks/9312-b7f510bd2d5a466b.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1831":"bd904a5c","2274":"51749ec1","9367":"b536a0f1"}[chunkId] || chunkId) + "." + {"1831":"3b0bf9b6092dc88e","2274":"758f1c5606fec8f1","4030":"beb1d4f3593a22fd","5184":"58efca4a6a3b29ab","6780":"4293df9cda5e902e","7537":"391e0b5164425ec0","9367":"9fe32b84329022c4","9860":"24ce17443445867d"}[chunkId] + ".js";
};